// Pedidos que se REPETEM sozinhos (lista, detalhe, contadores, presença).
//
// Caso do Gabriel, 11/09/2026: o tablet ficava "Offline" com a lista carregando
// pra sempre, e só voltava fechando o app. O servidor estava bem (o 👍 que ele
// esperava chegou no banco às 07:32:57); quem travava era o aparelho.
//
// A API fala HTTP/1.1, e o Chrome abre no máximo 6 conexões por servidor — uma
// fica presa com o tempo real (SSE). Os pollers disparavam a cada poucos
// segundos SEM esperar o anterior voltar, e SEM tempo limite: num soluço de
// rede os pedidos se acumulavam, as conexões lotavam, e tudo ficava esperando
// atrás de pedidos que nunca terminavam.
//
// Duas regras pra quem repete sozinho:
//   - tempo limite: pedido travado desiste e devolve a conexão. 20s é muito
//     mais que o normal (o banco responde a lista em ~30ms);
//   - não disparar com a tela escondida: tablet apagado não precisa atualizar
//     lista, e acordar com uma fila de pedidos atrasados é o que travava.
//
// NÃO é tempo limite global do axios de propósito: importar agenda, subir foto
// e consultar o ERP podem demorar de verdade.
export const TEMPO_DE_POLL_MS = 20000;

export function telaVisivel() {
  return typeof document === 'undefined' || !document.hidden;
}
